import { from } from 'rxjs/observable/from';

export * from './base.service';
export * from './auth/auth.service';
export * from './country.service';
export * from './province.service';
export * from './district.service';
export * from './ward.service';
export * from './role.service';
export * from './department.service';
export * from './hub.service';
export * from './user.service';
export * from './hubRoute.service';
export * from './hubRouting.service';
export * from './shipment.service';
export * from './requestShipment.service';
export * from './shipmentStatus.service';
export * from './reason.service';
export * from './service.service';
export * from './paymentType.service';
export * from './serviceDVGT.service';
export * from './customer.service';
export * from './structure.service';
export * from './packType.service';
export * from './package.service';
export * from './openPack.service.'
export * from './size.service'
export * from './areaGroup.service';
export * from './weightGroup.service';
export * from './weight.service';
export * from './formula.service';
export * from './area.service';
export * from './priceList.service';
export * from './priceService.service';
export * from './serviceDVGTPrice.service';
export * from './report.service'
export * from './cod.service'
export * from './priceServiceDetail.service';
export * from "./print.service";
export * from "./modulePage.service";
export * from "./page.service";
export * from "./customerType.service";
export * from "./formPrint.service";
export * from "./customerPaymentTo.service";



// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/services/index.ts